module.exports = __webpack_public_path__ + "static/media/homepage-hero5.d9cec30e.png";